import styled from 'styled-components';

export const ContainerStyled = styled.div`
  display: flex;
  align-items: end;
  gap: 16px;
`;

export const TextSearchContainerStyled = styled.div`
  width: 210px;
`;

export const SelectWrapperStyled = styled.div`
  min-width: 250px;
`;
